
import { constants } from '~/config'

const stories = Object.keys(constants.STORIES_BIJBELSE_NAMEN).map((slug) => {
  return {
    slug: slug,
    ...constants.STORIES_BIJBELSE_NAMEN[slug],
  }
})

export default {
  props: {
    // What story not to show as filter
    excludeStory: {
      type: String,
      validator: prop => stories.map((item) => item.slug).includes(prop),
      default: null,
    },
    // What type not to show as filter
    excludeType: {
      type: String,
      validator: prop => ['letter', 'sex', 'origin'].includes(prop),
      default: 'letter',
    },
  },
  data () {
    return {
      activeFilters: [],
    }
  },
  computed: {
    filters () {
      return stories.filter((item) => {
        return item.type !== this.excludeType && item.slug !== this.excludeStory
      })
    },
  },
  methods: {
    addFilter (item) {
      if (this.activeFilters.some(i => i.slug === item.slug)) return
      this.activeFilters.push(item)
      this.$emit('activeFilters', this.activeFilters)
    },
    removeFilter (item) {
      this.activeFilters = this.activeFilters.filter(i => i.slug !== item.slug)
      this.$emit('activeFilters', this.activeFilters)
    },
  },
}
